// src/pages/Settings.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WorkerSidebar from "../components/WorkerSidebar";
import axios from "axios";
import { FiEye, FiEyeOff } from "react-icons/fi";

const API_WRK = process.env.REACT_APP_API_WRK;

const Settings = () => {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const email = localStorage.getItem("userEmail");

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      return setMessage("All fields are required.");
    }

    if (newPassword !== confirmPassword) {
      return setMessage("New passwords do not match.");
    }

    try {
      await axios.post(`${API_WRK}/change-password`, {
        email,
        currentPassword,
        newPassword,
      });

      setMessage("Password updated successfully. Redirecting…");

      // 🔐 Clear auth/session data
      localStorage.removeItem("workerToken");
      localStorage.removeItem("workerId");
      localStorage.removeItem("workerStatus");

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");

      // ⏳ Redirect to welcome (login entry)
      setTimeout(() => {
        navigate("/dashboard", { replace: true });
      }, 1200);
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "Password update failed.");
    }
  };

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <WorkerSidebar />

      <div className="ml-60 p-8 w-full max-w-2xl">
        <h1 className="text-2xl font-semibold text-gray-800 mb-6">
          Change password
        </h1>

        <form
          onSubmit={handleChangePassword}
          className="bg-white rounded-2xl shadow-md p-6 space-y-4"
        >
          {/* Current Password */}
          <div className="relative">
            <input
              type={showCurrent ? "text" : "password"}
              placeholder="Current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
            />
            <span
              onClick={() => setShowCurrent(!showCurrent)}
              className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400"
            >
              {showCurrent ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          {/* New Password */}
          <div className="relative">
            <input
              type={showNew ? "text" : "password"}
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
            />
            <span
              onClick={() => setShowNew(!showNew)}
              className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400"
            >
              {showNew ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          {/* Confirm Password */}
          <div className="relative">
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
            />
            <span
              onClick={() => setShowConfirm(!showConfirm)}
              className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400"
            >
              {showConfirm ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Update password
          </button>

          {message && (
            <p className="text-sm text-red-500 text-center">{message}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Settings;
